import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/contexts/AuthContext";
import { ThemeProvider } from "@/contexts/ThemeContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import AppLayout from "@/components/layout/AppLayout";

import Login from "@/pages/Login";
import ChangePassword from "@/pages/ChangePassword";
import ResetPassword from "@/pages/ResetPassword";
import Dashboard from "@/pages/Dashboard";
import CrudPage from "@/pages/CrudPage";
import Users from "@/pages/Users";
import Settings from "@/pages/Settings";
import Reports from "@/pages/Reports";
import CreditorsDebtors from "@/pages/CreditorsDebtors";
import AuditLogs from "@/pages/AuditLogs";
import PriceList from "@/pages/PriceList";
import Approvals from "@/pages/Approvals";
import AccountStatement from "@/pages/AccountStatement";
import MyDay from "@/pages/dwr/MyDay";
import Tasks from "@/pages/dwr/Tasks";
import TeamReports from "@/pages/dwr/TeamReports";
import WorkDashboard from "@/pages/dwr/WorkDashboard";

const M = (key) => <CrudPage moduleKey={key} />;

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/change-password" element={
              <ProtectedRoute>
                <ChangePassword forced={true} />
              </ProtectedRoute>
            } />

            <Route element={<ProtectedRoute><AppLayout /></ProtectedRoute>}>
              <Route path="/" element={<Navigate to="/dashboard" replace />} />
              <Route path="/dashboard" element={<Dashboard />} />

              {/* Daily Work Reports & tasks */}
              <Route path="/dwr/my-day" element={<MyDay />} />
              <Route path="/dwr/tasks" element={<Tasks />} />
              <Route path="/dwr/reports" element={<TeamReports />} />
              <Route path="/dwr/dashboard" element={<WorkDashboard />} />

              {/* CRM */}
              <Route path="/crm/leads" element={M("crm-leads")} />
              <Route path="/crm/customers" element={M("crm-customers")} />
              <Route path="/crm/invoices" element={M("crm-invoices")} />
              <Route path="/crm/sales-orders" element={M("crm-sales-orders")} />
              <Route path="/crm/service-contracts" element={M("crm-contracts")} />

              {/* Purchases */}
              <Route path="/purchases/suppliers" element={M("pur-suppliers")} />
              <Route path="/purchases/requisitions" element={M("pur-requisitions")} />
              <Route path="/purchases/orders" element={M("pur-orders")} />
              <Route path="/purchases/invoices" element={M("pur-supplier-invoices")} />
              <Route path="/purchases/grn" element={M("pur-grn")} />

              {/* Accounting */}
              <Route path="/accounting/chart" element={M("acc-chart")} />
              <Route path="/accounting/statement/:accountName" element={<AccountStatement />} />
              <Route path="/accounting/journals" element={M("acc-journals")} />
              <Route path="/accounting/expenses" element={M("acc-expenses")} />
              <Route path="/accounting/deposits" element={M("acc-deposits")} />
              <Route path="/accounting/transfers" element={M("acc-transfers")} />
              <Route path="/accounting/budgets" element={M("acc-budgets")} />
              <Route path="/accounting/petty-cash" element={M("acc-petty-cash")} />

              <Route path="/creditors-debtors" element={<CreditorsDebtors />} />

              {/* Inventory */}
              <Route path="/inventory/categories" element={M("inv-categories")} />
              <Route path="/inventory/office-items" element={M("inv-office-items")} />
              <Route path="/inventory/equipments" element={M("inv-equipments")} />
              <Route path="/inventory/movements" element={M("inv-movements")} />

              {/* Assets */}
              <Route path="/assets/register" element={M("ast-register")} />
              <Route path="/assets/maintenance" element={M("ast-maintenance")} />

              {/* HRM */}
              <Route path="/hrm/employees" element={M("hr-employees")} />
              <Route path="/hrm/departments" element={M("hr-departments")} />
              <Route path="/hrm/designations" element={M("hr-designations")} />
              <Route path="/hrm/leaves" element={M("hr-leaves")} />
              <Route path="/hrm/payroll" element={M("hr-payroll")} />
              <Route path="/hrm/holidays" element={M("hr-holidays")} />

              {/* Service */}
              <Route path="/service/tickets" element={M("svc-tickets")} />
              <Route path="/service/work-orders" element={M("svc-work-orders")} />
              <Route path="/service/device-registry" element={M("svc-device-registry")} />

              {/* Approvals (auto-gated by role inside the page) */}
              <Route path="/approvals" element={<Approvals />} />

              <Route path="/price-list" element={<PriceList />} />
              <Route path="/reports" element={<Reports />} />
              <Route path="/audit-logs" element={<AuditLogs />} />
              <Route path="/users" element={<Users />} />
              <Route path="/settings" element={<Settings />} />
            </Route>

            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
